import { createNamespace } from '../utils';
var status1 = 'http://mui.ucmed.cn/images/figure/order_status2@2x.png';
var status2 = 'http://mui.ucmed.cn/images/figure/order_status1@2x.png';
var status3 = 'http://mui.ucmed.cn/images/figure/order_status5@2x.png';
var status4 = 'http://mui.ucmed.cn/images/figure/order_status3@2x.png';
var status5 = 'http://mui.ucmed.cn/images/figure/order_status9@2x.png';
var status6 = 'http://mui.ucmed.cn/images/figure/order_status7@2x.png';
var status7 = 'http://mui.ucmed.cn/images/figure/order_status4@2x.png';
var status8 = 'http://mui.ucmed.cn/images/figure/order_status6@2x.png';
var status9 = 'http://mui.ucmed.cn/images/figure/order_status8@2x.png';
var status10 = 'http://mui.ucmed.cn/images/figure/order_status10@2x.png';
var status11 = 'http://mui.ucmed.cn/images/figure/order_status11@2x.png';
var status12 = 'http://mui.ucmed.cn/images/figure/order_status12@2x.png';
var status13 = 'http://mui.ucmed.cn/images/figure/order_status13@2x.png';
var status1x14 = 'http://mui.ucmed.cn/images/figure/fail.png';
var status2x14 = 'http://mui.ucmed.cn/images/figure/fail1.png';
var status1x15 = 'http://mui.ucmed.cn/images/figure/failcall.png';
var status2x15 = 'http://mui.ucmed.cn/images/figure/failcall1.png';
var status1x16 = 'http://mui.ucmed.cn/images/figure/noconsulted.png';
var status2x16 = 'http://mui.ucmed.cn/images/figure/noconsulted1.png';
var status1x17 = 'http://mui.ucmed.cn/images/figure/success.png';
var status2x17 = 'http://mui.ucmed.cn/images/figure/success1.png';
var status1x18 = 'http://mui.ucmed.cn/images/figure/waiting.png';
var status2x18 = 'http://mui.ucmed.cn/images/figure/waiting1.png';

var _createNamespace = createNamespace('status'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    orient: {
      type: String,
      default: 'horizontal'
    },
    type: {
      type: String,
      default: '1'
    },
    figure: {
      type: [Number, String],
      default: 1
    },
    title: String,
    tip: String,
    background: String
  },
  data: function data() {
    return {
      status1: status1,
      status2: status2,
      status3: status3,
      status4: status4,
      status5: status5,
      status6: status6,
      status7: status7,
      status8: status8,
      status9: status9,
      status10: status10,
      status11: status11,
      status12: status12,
      status13: status13,
      status1x14: status1x14,
      status2x14: status2x14,
      status1x15: status1x15,
      status2x15: status2x15,
      status1x16: status1x16,
      status2x16: status2x16,
      status1x17: status1x17,
      status2x17: status2x17,
      status1x18: status1x18,
      status2x18: status2x18
    };
  },
  methods: {
    genFigure: function genFigure() {
      if (typeof this.figure === 'number') {
        switch (this.figure) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
            return this["status" + this.figure];

          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
            return this["status" + this.type + "x" + this.figure];
        }
      } else {
        return this.figure;
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var slots = this.slots,
        orient = this.orient,
        type = this.type,
        figure = this.figure,
        title = this.title,
        tip = this.tip,
        background = this.background;

    if (orient !== 'horizontal' && orient !== 'vertical') {
      return;
    }

    return h("div", {
      "class": bem([orient, orient + "-type" + type]),
      "style": {
        background: background
      }
    }, [orient === 'vertical' && (slots('figure') || figure && h("img", {
      "class": bem('figure'),
      "attrs": {
        "src": this.genFigure()
      }
    })), h("div", [slots('default'), title && h("p", {
      "class": bem('title')
    }, [" ", title, " "]), tip && h("p", {
      "class": bem('tip')
    }, [" ", tip, " "])]), orient === 'horizontal' && (slots('figure') || figure && h("img", {
      "class": bem('figure'),
      "attrs": {
        "src": this.genFigure()
      }
    }))]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/status/index.js
// module id = null
// module chunks = 